export default {"src":"/_next/static/media/define-scope-and-objectives.23ea8527.svg","height":330,"width":330,"blurWidth":0,"blurHeight":0};